<template>
  <SeverityModal
    data-test-id="severy-modal-test"
    :primaryButtonProps="primaryButtonProps"
    :showModal="showModal"
    title="Delete Registration"
    variant="sev1"
    @close="handleClose"
    @save="handleSave"
  >
    <template v-slot:body>
      <ParagraphBody>
        Please read before proceeding!
      </ParagraphBody>
      <ParagraphBody
        data-test-id="ActionsModal__handleDelete"
      >
        Deleting your registration cannot be undone.
        If you choose to proceed the following will occur,
        and you will need to re-enroll from the starting point.
      </ParagraphBody>
    </template>
  </SeverityModal>
</template>
<script>
import {
  ParagraphBody, SeverityModal,
} from '@jumpcloud/ui-components';

export default {
  name: 'DeleteModal',

  components: {
    ParagraphBody,
    SeverityModal,
  },

  props: {
    actionItem: {
      type: Array,
      required: true,
    },
    primaryButtonProps: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClose() {
      this.$emit('handleClose');
    },

    handleSave() {
      this.$emit('handleSave');
    },
  },

};
</script>
